import { render } from "./Warehouses.vue?vue&type=template&id=a66b8522&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"

import "./Warehouses.vue?vue&type=style&index=0&id=a66b8522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66b8522"]])

export default __exports__